import { TextField } from "@mui/material";
import { InputHTMLAttributes, ReactNode } from "react";

type TextFieldReadOnlyProps = {
  inputProps: InputHTMLAttributes<HTMLInputElement>;
  label?: ReactNode;
};

export const TextFieldReadOnly = ({ inputProps, label, ...rest }: TextFieldReadOnlyProps) => {
  return (
    <TextField
      {...rest}
      label={label}
      InputLabelProps={{ shrink: true }}
      inputProps={{ ...inputProps, readOnly: true }}
    />
  );
};
